var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsuccess({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 99,
    height: 99,
    viewBox: "0 0 99 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 49.5,
    cy: 49.5,
    r: 49.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 49.5,
    cy: 49.5,
    r: 37.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 23.75C56.9619 23.75 63.6387 26.5156 68.5616 31.4384C73.4844 36.3613 76.25 43.0381 76.25 50C76.25 56.9619 73.4844 63.6387 68.5616 68.5616C63.6387 73.4844 56.9619 76.25 50 76.25C43.0381 76.25 36.3613 73.4844 31.4384 68.5616C26.5156 63.6387 23.75 56.9619 23.75 50C23.75 43.0381 26.5156 36.3613 31.4384 31.4384C36.3613 26.5156 43.0381 23.75 50 23.75ZM46.73 55.1787L40.8988 49.3438C40.6897 49.1347 40.4415 48.9689 40.1684 48.8557C39.8953 48.7426 39.6025 48.6844 39.3069 48.6844C39.0112 48.6844 38.7185 48.7426 38.4454 48.8557C38.1722 48.9689 37.924 49.1347 37.715 49.3438C37.2928 49.7659 37.0556 50.3386 37.0556 50.9356C37.0556 51.5327 37.2928 52.1053 37.715 52.5275L45.14 59.9525C45.3485 60.1626 45.5964 60.3294 45.8696 60.4432C46.1429 60.557 46.4359 60.6156 46.7319 60.6156C47.0278 60.6156 47.3209 60.557 47.5941 60.4432C47.8673 60.3294 48.1153 60.1626 48.3237 59.9525L63.6987 44.5737C63.9106 44.3656 64.0791 44.1175 64.1946 43.8439C64.3101 43.5702 64.3703 43.2764 64.3717 42.9794C64.373 42.6824 64.3156 42.3881 64.2027 42.1134C64.0897 41.8387 63.9235 41.5891 63.7136 41.3789C63.5037 41.1688 63.2543 41.0023 62.9797 40.889C62.7052 40.7757 62.4109 40.7179 62.1139 40.719C61.8169 40.72 61.523 40.7798 61.2492 40.895C60.9754 41.0102 60.7272 41.1784 60.5188 41.39L46.73 55.1787Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsuccess);
export default __webpack_public_path__ + "static/media/paymentsuccess.9d3d4bb0490e8a4459b65f97f06f6b34.svg";
export { ForwardRef as ReactComponent };